import React from 'react'
import { Accordion } from '@mobi/component-library/Base/Accordion'

export const ExpandableToolboxSection: React.FC<
  { heading: string; shouldUseTheme?: boolean } & React.PropsWithChildren
> = ({ heading, children, shouldUseTheme = false }) => {
  return (
    <Accordion shouldUseDefaultTheme={shouldUseTheme} title={heading}>
      <div style={{ paddingBottom: '1rem' }}>{children}</div>
    </Accordion>
  )
}
